const messages = {
    accountBox: {
        title: "Dashboard",
        description: "Tieni sotto controllo rapidamente promozioni e punti.",
        button: "APRI DASHBOARD",
    },
};

export default {
    messages,
};
